export enum BranchOfficeRole {
  MANAGER = 'MANAGER',
  PLANNER = 'PLANNER',
  SPECTATOR = 'SPECTATOR',
}
